import React from 'react'
import './Progress.scss'

const Progress = props => {
  return (
    <div className="progress-signup">
      <div className="progress-signup__wrapper">
        {props.progress.map( (step, key) => {
          let status = step.id === props.step ? ' current' : step.id < props.step ? ' done' : ''
          let stepClassName = `progress-signup__step${status}`
          return <div className={stepClassName} key={key}>
            <div className="number">{key + 1}</div>
            <div className="label">{step.name}</div>
          </div>
        })}
      </div>
    </div>
  )
}

export default Progress



// WEBPACK FOOTER //
// ./src/components/Progress/Progress.js